<template>
  <div>
    <va-inner-loading :loading="loader">
      <va-card class="mb-4">
        <div class="d-flex justify--space-between align--center mb-3">
          <h1 class="ma-0">Календарь доставки</h1>
          <va-button color="info" @click="openCreateModal">
            Добавить запись
          </va-button>
        </div>
        <va-data-table
          :fields="fields"
          :data="list"
          class="va-table va-table--hoverable"
        >
          <template slot="date" slot-scope="props">
            {{ props.rowData.date }}
          </template>
          <template slot="is_working_day" slot-scope="props">
            <va-badge
              :text="props.rowData.is_working_day ? 'Да' : 'Нет'"
              :color="props.rowData.is_working_day ? 'success' : 'gray'"
            />
          </template>
          <template slot="delivery_type" slot-scope="props">
            {{ getTypeTitle(props.rowData.delivery_type_id) }}
          </template>
          <template slot="price_override" slot-scope="props">
            {{
              props.rowData.price_override != null
                ? props.rowData.price_override
                : "—"
            }}
          </template>
          <template slot="comment" slot-scope="props">
            {{ props.rowData.comment || "—" }}
          </template>
          <template slot="actions" slot-scope="props">
            <va-button
              flat
              small
              color="gray"
              icon="fa fa-pencil"
              @click="edit(props.rowData)"
            />
            <va-button
              flat
              small
              color="gray"
              icon="fa fa-trash"
              @click="remove(props.rowData.id)"
            />
          </template>
        </va-data-table>
      </va-card>
    </va-inner-loading>

    <va-modal v-model="showModal" hide-default-actions size="medium">
      <template #header>
        <span>{{ editId ? "Редактировать" : "Новая запись календаря" }}</span>
      </template>
      <DeliveryCalendarForm
        :initial="editItem"
        :delivery-types="typeOptions"
        @submit="onSubmit"
        @cancel="closeModal"
      />
    </va-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import DeliveryCalendarForm from "../../components/delivery-management/DeliveryCalendarForm.vue";

export default {
  name: "DeliveryCalendar",
  components: { DeliveryCalendarForm },
  data() {
    return {
      showModal: false,
      editId: null,
      editItem: null,
    };
  },
  computed: {
    ...mapState("deliveryCalendar", ["list"]),
    ...mapGetters({ loader: "isLoading" }),
    typesList() {
      return this.$store.state.deliveryTypes.list || [];
    },
    typeOptions() {
      const list = this.typesList;
      return [
        { value: null, text: "Все типы" },
        ...list.map((t) => ({ value: t.id, text: t.title })),
      ];
    },
    fields() {
      return [
        { name: "__slot:date", title: "Дата" },
        { name: "__slot:is_working_day", title: "Рабочий день" },
        { name: "__slot:delivery_type", title: "Ограничение типа" },
        { name: "__slot:price_override", title: "Надбавка к цене" },
        { name: "__slot:comment", title: "Комментарий" },
        { name: "__slot:actions", title: "", width: "100px" },
      ];
    },
  },
  async created() {
    await Promise.all([
      this.$store.dispatch("deliveryTypes/fetchList"),
      this.fetchList(),
    ]);
  },
  methods: {
    ...mapActions("deliveryCalendar", [
      "fetchList",
      "create",
      "update",
      "delete",
    ]),
    getTypeTitle(id) {
      if (id == null) return "—";
      const t = this.typesList.find((x) => Number(x.id) === Number(id));
      return t ? t.title : "—";
    },
    openCreateModal() {
      this.editId = null;
      this.editItem = null;
      this.showModal = true;
    },
    edit(row) {
      this.editId = row.id;
      this.editItem = { ...row };
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.editId = null;
      this.editItem = null;
    },
    async onSubmit(form) {
      try {
        if (this.editId) {
          await this.update({ id: this.editId, ...form });
          this.$notify?.({ type: "success", title: "Сохранено" });
        } else {
          await this.create(form);
          this.$notify?.({ type: "success", title: "Создано" });
        }
        this.closeModal();
      } catch (e) {
        this.$notify?.({
          type: "error",
          title: "Ошибка",
          text: e.response?.data?.message || "Ошибка",
        });
      }
    },
    async remove(id) {
      if (!confirm("Удалить запись?")) return;
      try {
        await this.delete(id);
        this.$notify?.({ type: "success", title: "Удалено" });
      } catch (e) {
        this.$notify?.({
          type: "error",
          title: "Ошибка",
          text: e.response?.data?.message || "Ошибка",
        });
      }
    },
  },
};
</script>
